<div>
    <div class="title">{{localizationKeys.aumico_reports_registration_confirmation_title | i18next }}</div>
    <div class="paragraph">
        {{localizationKeys.aumico_reports_registration_confirmation_introduction | i18next}}
    </div>
</div>
<div class="inline-div">
    <button
        aum-icon-button
        color="basic"
        size="small"
        *ngFor="let item of mailButtonsDataArray"
        class="mail-button-margins"
        (click)="onMailButtonClicked(item)"
        [icon]="item.icon"
    >
        {{item.text}}
    </button>
</div>

<app-component-random-questions-with-action-button
    [question]="questionTextKey"
    [actionButton]="{title: questionButtonTextKey, action: onResendPressed.bind(this)}"
>
</app-component-random-questions-with-action-button>
